import React, { ReactNode, createContext, useContext, useState } from "react";
import { Coupon } from "../components/CouponPage/types";
import membershipPrice from "../data/memberShipPrice";

type CouponContext = {
  coupon: Coupon;
  updateCoupon: (coupon: Coupon) => void;
};

const defaultCoupon = {
  id: "NULL",
  createdTime: "",
  fields: {
    remainingQuantity: 1,
    price: membershipPrice,
    category: "",
    pricePerPerson: membershipPrice,
    discountedPrice: membershipPrice,
    companyName: "",
    totalQuantity: 1,
    cupom: "",
    discount: 0,
    companyId: null,
  },
};

const CouponContext = createContext<CouponContext>({
  coupon: defaultCoupon,
  updateCoupon: () => {},
});

export const CouponContextProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [coupon, updateCoupon] = useState<Coupon>(defaultCoupon);
  return <CouponContext.Provider value={{ coupon, updateCoupon }}>{children}</CouponContext.Provider>;
};

export const useCouponContext = () => useContext(CouponContext);
